import { c as _c } from "react/compiler-runtime";
import { IcoSpeedometer24 } from '@onefootprint/icons';
import type { Document } from '@onefootprint/request-types/dashboard';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import CollapsibleSection from '../collapsible-section';
import ConfidenceScore from './components/confidence-score';
type ConfidenceScoresProps = {
  document: Document | Omit<Document, 'uploads'>;
};
const ConfidenceScores = t0 => {
  const $ = _c(22);
  const {
    document
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "fieldset.documents.details.confidenceScores"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = [t2, t3];
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const confidenceScoreLabels = t4;
  const t5 = document?.documentScore;
  const t6 = document?.selfieScore;
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = [t5, t6];
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const confidenceScores = t7;
  let t8;
  if ($[11] !== confidenceScores) {
    t8 = confidenceScores.filter(_temp3);
    $[11] = confidenceScores;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const numScores = t8.length;
  if (numScores === 0) {
    return null;
  }
  let t9;
  if ($[13] !== t) {
    t9 = t(_temp4);
    $[13] = t;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== confidenceScoreLabels || $[16] !== confidenceScores || $[17] !== numScores) {
    t10 = <div className="flex justify-between gap-5 w-full">{confidenceScores.map((score_0, index) => score_0 || score_0 === 0 ? <div className={cx("flex flex-col gap-1 justify-start w-full", {
        "items-start": numScores > 1,
        "items-center": numScores === 1,
        "border-r border-tertiary": index < numScores - 1
      })} key={confidenceScoreLabels[index]}><ConfidenceScore label={confidenceScoreLabels[index]} score={score_0} /></div> : null)}</div>;
    $[15] = confidenceScoreLabels;
    $[16] = confidenceScores;
    $[17] = numScores;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t9) {
    t11 = <CollapsibleSection icon={IcoSpeedometer24} title={t9} defaultOpen={true}>{t10}</CollapsibleSection>;
    $[19] = t10;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  return t11;
};
export default ConfidenceScores;
function _temp($) {
  return $.labels.document;
}
function _temp2($_0) {
  return $_0.labels.faceMatch;
}
function _temp3(score) {
  return score || score === 0;
}
function _temp4($_1) {
  return $_1.title;
}